// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, object, string } from 'prop-types'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import RadioGroup from './RadioGroup'

class RadioGroupFromState extends React.Component {
  static propTypes = {
    emptyOptionLabel: string,
    idRoot: string.isRequired,
    label: string,
    name: string.isRequired,
    onChangeCustom: func,
    optionsImmutable: object.isRequired,
    targetSet: array.isRequired,
    valueKeyRoot: string,
  }

  state = {
    options: [],
  }

  componentWillMount () {
    // assign the options to state
    const {
      emptyOptionLabel,
      optionsImmutable,
      targetSet,
      valueKeyRoot,
    } = this.props
    // if there's a valueKeyRoot, the naming convention of the entity doens't follow the simple pattern
    // otherwise the simple pattern is to take the pluralized entity name from targetSet[1] and remove the last 's'
    // example ['radioSettings', 'modulationTypes'] ==> 'modulationType'
    const labelKey = valueKeyRoot || targetSet.slice(-1)[0].slice(0, -1)

    // assumes entity id prop will just be the entity name with 'Id' added to the end.
    const valueKey = `${labelKey}Id`

    const optionsBasis = []

    // allows the radio group to have a null option.
    if (emptyOptionLabel) {
      optionsBasis.push({
        label: emptyOptionLabel,
        value: '',
      })
    }

    // create simplified options list to feed to RadioGroup
    const options = optionsImmutable.reduce((a, d, i) => {
      a.push({
        label: d.get(labelKey),
        value: `${d.get(valueKey)}`,
      })
      return a
    }, optionsBasis)

    this.setState(() => ({ options }))
  }

  render () {
    const {
      idRoot,
      label,
      name,
      onChangeCustom,
    } = this.props

    return (
      <Field
        className={'flat-radios'}
        component={RadioGroup}
        idRoot={idRoot}
        label={label}
        name={name}
        onChangeCustom={onChangeCustom}
        options={this.state.options} />
    )
  }
}

const mapStateToProps = ({ domain }, { targetSet }) => ({
  optionsImmutable: domain.getIn(targetSet),
})

export default connect(
  mapStateToProps,
)(RadioGroupFromState)
